import React from "react";
import Wsis from "../Images/2016-WSIS-ActionLineC7.webp";
import Modiran from "../Images/modiran.jpg";
import Parvane2 from "../Images/parvane2.jpg";
import Rahavard from "../Images/rahavard.jpg";
import Fab from "../Images/fab.png";
import goldIcon from "../Images/gold-medal-icon.png";
import Poster from "../Images/poster311.png";
import HeaderBanner from "../Components/HeaderBanner";
import { Col, Container, Row } from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import Config from "../config.json";
import { t } from "../lib/utils";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | افتخارات",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const Awards = () => {
  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner
        header_color="#fffada"
        title={"افتخارات پژوهیار"}
        body={t("awardsHeaderBody")}
        image={Fab}
        headerSize="2.6rem"
      />
      <Container className="overflow-hidden">
        <Row className="justify-content-center award-card mx-0 p-3">
          <Col sm={2}>
            <div className="justify-content-center pt-3 pb-3">
              <p className="text-center">
                <img alt="fab" src={Fab} className="img-fluid award-img" />
              </p>
            </div>
          </Col>
          <Col sm={10} className="align-self-center">
            <div className="justify-content-end pt-3 pb-3 award-desc ">
              <h2 className="font-weight-bold">
                {" "}
                کسب مقام سوم فاب (فناوری اطلاعات برتر)
              </h2>
              <p className="pt-3">
                جایزه فاب : در چهارمین همایش ملی مدیران فناوری اطلاعات
                <br /> نمایشگاه : همایش ملی مدیران فناوری اطلاعات
                <br /> نوع نمایشگاه : همایش ها
                <br /> اهدا کننده : معاون پژوهش و فناوری علوم تحقیقات و فناوری
                رئیس پژوهشگاه علوم و فناوری اطلاعات ایران (ایرانداک)
                <br /> کشور: ایران - استان تهران - شهر تهران - 1395/7/5
              </p>
            </div>
          </Col>
          <img alt="fab" src={goldIcon} className="gold-icon" />
        </Row>
        <hr />
        <Row className="justify-content-center award-card mx-0 p-3">
          <Col sm={9} className="align-self-center">
            <div className="justify-content-start pt-3 pb-3 award-desc">
              <h2 className="font-weight-bold ">
                {" "}
                نامزد جایزه جهانی جامعه اطلاعاتی WSIS
              </h2>
              <p className="pt-3">
                در اجلاس جهانی سران جامعه اطلاعاتی wsis
                <br /> اردیبهشت 1395 / WSIS 2016
                <br /> شهر ژنو کشور سوئیس- تاریخ 17 اردیبهشت 1395
              </p>
            </div>
          </Col>
          <Col sm={3}>
            <div className="justify-content-center pt-3 pb-3">
              <p className="text-center">
                <img alt="wsis" src={Wsis} className="imageshadow award-img" />
              </p>
            </div>
          </Col>
          <img alt="fab" src={goldIcon} className="gold-icon2" />
        </Row>
        <hr />
        <Row className="justify-content-center award-card mx-0 p-3">
          <Col sm={3}>
            <div className="justify-content-center pt-3 pb-3">
              <p className="text-center">
                <img
                  alt="modiran"
                  src={Modiran}
                  className="imageshadow award-img"
                />
              </p>
            </div>
          </Col>
          <Col sm={9} className="align-self-center ">
            <div className="justify-content-end pt-3 pb-3 award-desc ">
              <h2 className=" font-weight-bold">
                دست‌آورد برتر اولین همایش مدیران
              </h2>
              <p className="pt-3">
                نمایشگاه : همایش ملی مدیران فناوری اطلاعات
                <br /> نوع نمایشگاه : همایش ها
                <br /> اهدا کننده: سید امید فاطمی : رئیس پژوهشگاه علوم و فناوری
                اطلاعات ایران و رئیس همایش
                <br /> کشور: ایران - استان تهران - شهر تهران - 1392/2/1
              </p>
            </div>
          </Col>
          <img alt="fab" src={goldIcon} className="gold-icon" />
        </Row>
        <hr />
        <Row className="justify-content-center award-card mx-0 p-3">
          <Col sm={7} className="align-self-center">
            <div className="justify-content-start pt-3 pb-3 award-desc">
              <h2 className="font-weight-bold">پروانه انتشار نرم‌افزار </h2>

              <p className="pt-3">
                نسخه 1- نسخه 1.5- نسخه 2- نسخه 3
                <br /> سازمان صادر کننده: وزارت فرهنگ و ارشاد اسلامی
              </p>
            </div>
          </Col>
          <Col sm={5}>
            <div className="justify-content-center pt-3 pb-3">
              <p className="text-center">
                <img
                  alt="parvane2"
                  src={Parvane2}
                  className="imageshadow award-img"
                />
              </p>
            </div>
          </Col>
          <img alt="fab" src={goldIcon} className="gold-icon2" />
        </Row>
        <hr />
        <Row className="justify-content-center award-card mx-0 p-3">
          <Col sm={3}>
            <div className="justify-content-center pt-3 pb-3">
              <p className="text-center">
                <img
                  alt="rahavard"
                  src={Rahavard}
                  className="imageshadow award-img"
                />
              </p>
            </div>
          </Col>
          <Col sm={9} className="align-self-center">
            <div className="justify-content-end pt-3 pb-3 award-desc">
              <h2 className=" font-weight-bold">
                ویژه‌نامه «پژوهیار» فصلنامه ره‌آورد نور
              </h2>
              <p className="pt-3">
                نشریه داخلی مرکز تحقیقات کامپوتری علوم اسلامی نور
                <br /> شماره -40 سال 1391
              </p>
            </div>
          </Col>
          <img alt="fab" src={goldIcon} className="gold-icon" />
        </Row>
        <hr />
        <Row className="justify-content-center award-card mx-0 p-3">
          <Col sm={9} className="align-self-center">
            <div className="justify-content-start pt-3 pb-3 award-desc">
              <h2 className=" font-weight-bold">
                پوستر برتر کنفرانس کتابخانه دیجیتالی
              </h2>
              <p className="pt-3">
                برگزار کننده : پژوهشگاه علوم و فناوری اطلاعات ایران
                <br /> تاریخ برگزاری: بهمن 1392
                <br /> محل برگزاری: تهران
              </p>
            </div>
          </Col>
          <Col sm={3}>
            <div className="justify-content-center pt-3 pb-3">
              <p className="text-center">
                <img
                  alt="poster"
                  src={Poster}
                  className="imageshadow award-img"
                />
              </p>
            </div>
          </Col>
          <img alt="fab" src={goldIcon} className="gold-icon2" />
        </Row>
      </Container>
    </DocumentMeta>
  );
};

export default Awards;
